import React from 'react'
import Skeleton from 'react-loading-skeleton'
import {
  FooterContainer,
  FooterTop,
  FooterGeneralInfo,
  FooterLogo,
  FooterContact,
  FooterMenu,
  CopyrightText,
} from 'components/Footer/Footer.style'

const FooterSkeleton = () => {
  return (
    <FooterContainer>
      <FooterTop>
        <FooterGeneralInfo>
          {/* Logo skeleton */}
          <FooterLogo to="/">
            <Skeleton
              width={180}
              height={60}
              baseColor="#1e293b"
              highlightColor="#334155"
              className="!rounded-md"
            />
          </FooterLogo>

          {/* Contact info skeleton */}
          <FooterContact>
            <Skeleton
              width={120}
              height={16}
              baseColor="#334155"
              highlightColor="#475569"
              className="mb-2 !rounded-sm"
            />
            <Skeleton
              width={140}
              height={14}
              baseColor="#334155"
              highlightColor="#475569"
              className="mb-3 !rounded-sm"
            />
            <Skeleton
              width={80}
              height={16}
              baseColor="#334155"
              highlightColor="#475569"
              className="mb-2 !rounded-sm"
            />
            <Skeleton
              width={200}
              height={14}
              baseColor="#334155"
              highlightColor="#475569"
              className="mb-1 !rounded-sm"
            />
            <Skeleton
              width={160}
              height={14}
              baseColor="#334155"
              highlightColor="#475569"
              className="!rounded-sm"
            />
          </FooterContact>
        </FooterGeneralInfo>

        <div className="flex flex-col md:flex-row">
          {/* Footer menu skeletons */}
          {Array(3)
            .fill()
            .map((_, index) => (
              <FooterMenu key={index}>
                {/* Menu title skeleton */}
                <Skeleton
                  width={100 + index * 20}
                  height={18}
                  baseColor="#334155"
                  highlightColor="#475569"
                  className="mb-4 !rounded-sm"
                />

                {/* Menu items skeleton */}
                <ul>
                  {Array(4 + index)
                    .fill()
                    .map((_, itemIndex) => (
                      <li key={itemIndex} className="py-1">
                        <Skeleton
                          width={80 + itemIndex * 15}
                          height={12}
                          baseColor="#334155"
                          highlightColor="#475569"
                          className="!rounded-sm"
                        />
                      </li>
                    ))}
                </ul>
              </FooterMenu>
            ))}
        </div>
      </FooterTop>

      {/* Payment and social section skeleton */}
      <div className="footer flex flex-col md:flex-row pt-4 justify-between gap-y-4 gap-x-4 md:pr-10">
        {/* Payment methods skeleton */}
        <div className="footer-payment justify-center flex flex-row gap-x-4">
          {Array(3)
            .fill()
            .map((_, index) => (
              <Skeleton
                key={index}
                width={60}
                height={25}
                baseColor="#334155"
                highlightColor="#475569"
                className="!rounded-sm"
              />
            ))}
        </div>

        {/* Social media skeleton */}
        <div className="footer-social justify-center flex flex-row gap-x-4">
          {Array(3)
            .fill()
            .map((_, index) => (
              <Skeleton
                key={index}
                width={24}
                height={24}
                baseColor="#334155"
                highlightColor="#475569"
                className="!rounded-sm"
              />
            ))}
        </div>
      </div>

      {/* Copyright skeleton */}
      <CopyrightText>
        <Skeleton
          width={300}
          height={14}
          baseColor="#334155"
          highlightColor="#475569"
          className="!rounded-sm"
        />
      </CopyrightText>
    </FooterContainer>
  )
}

export default FooterSkeleton
